// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__pYt4C","child1":"style_child1__oGLIL","child2":"style_child2__smCg3"};